module.exports = __webpack_public_path__ + "4efffd341e53dc5dd70406699fd869f3.pdf";